import { useState } from "react";
import { useFetch } from "@/lib/hooks";
import { fmtDate } from "@/lib/format";
import { Empty, Loading, PageHeader, Panel, Table, cellCls } from "@/components/common";
import { Input } from "@/components/ui/input";

export default function Audit() {
  const [q, setQ] = useState("");
  const { data, loading } = useFetch<any[]>(`/audit?q=${encodeURIComponent(q)}`);
  return (
    <div>
      <PageHeader eyebrow="Traçabilité" title="Journal des actions sensibles" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrer par action : facture, avoir, logo, connexion…" className="mb-6 h-11 max-w-md" data-testid="audit-filter-input" />
      <Panel>
        {loading ? <Loading /> : !data?.length ? <Empty text="Aucune entrée" /> : (
          <Table head={["Date", "Utilisateur", "Action", "Détails"]} testId="audit-table">
            {data.map((a) => (
              <tr key={a.id} className="border-b border-border/60 align-top">
                <td className={`${cellCls} whitespace-nowrap text-muted-foreground`}>{fmtDate(a.at)}</td>
                <td className={cellCls}>{a.user_name}</td>
                <td className={`${cellCls} font-mono-data text-xs`}>{a.action}</td>
                <td className={`${cellCls} max-w-xl text-xs text-muted-foreground`}>
                  {Object.entries(a.details || {}).map(([k, v]) => <span key={k} className="mr-3 inline-block">{k} : <span className="text-foreground">{typeof v === "object" ? JSON.stringify(v) : String(v)}</span></span>)}
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
